<div class="loader-container" *ngIf="showLoader$ | async">
  <div class="loader-and-label-container">
    <div class="loader"></div>
    <div class="label" *ngFor="let text of loaderTexts$ | async">
      {{ text }}
    </div>
  </div>
</div>
